import request from '@/request'

export async function getBook(id) {
    const response = await request({
        url: `/books/${id}`,
        method: 'get'
    })

    return response.data
}

export async function getAllBooks() {
    const response = await request({
        url: `/books`,
        method: 'get'
    })

    return response.data
}

export async function getBookDownloadUrl(id) {
    const response = await request({
        url: `/download`,
        method: 'post',
        data: { type: 'book', id }
    })

    return response.data
}